import React from "react";
import { FaPlus, FaChevronDown } from "react-icons/fa";
import Select, { components } from "react-select";

const CustomSelect = ({
  options,
  value,
  onChange,
  placeholder,
  valueKey = "value",
  labelKey = "label",
  isAutocomplete = false,
  onAddNew,
}) => {
  const formattedOptions = [
    { value: "ALL", label: "Todos" },
    ...options.map((option) => ({
      value: option[valueKey],
      label: option[labelKey],
    })),
  ];

  const handleChange = (selectedOption) => {
    onChange(selectedOption ? selectedOption.value : "");
  };

  // Componente personalizado para mostrar el dropdown indicator
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <FaChevronDown color="#8F99A6" size={14} />
      </components.DropdownIndicator>
    );
  };

  if (isAutocomplete) {
    return (
      <div className="poppins-regular relative">
        <Select
          value={
            formattedOptions.find((option) => {
              // Asegurar que ALL sea tratado como string
              return String(option.value) === String(value ?? "ALL");
            }) || null
          }
          onChange={handleChange}
          options={formattedOptions}
          placeholder={placeholder}
          classNames={"poppins-regular"}
          components={{
            DropdownIndicator, // Agregamos el nuevo indicador de dropdown
            IndicatorSeparator: () => null, // Ocultar el separador
          }}
          noOptionsMessage={() => (
            <div
              className="flex items-center justify-between px-2 py-1 cursor-pointer"
              onClick={onAddNew}
            >
              <span className="text-gray-500 text-sm">Agregar</span>
              <FaPlus color="#C9C9C9" size={14} />
            </div>
          )}
          styles={{
            control: (base) => ({
              ...base,
              backgroundColor: "#F3F3F3",
              padding: "4px 8px",
              fontSize: "12px",
              minWidth: "150px",
              maxWidth: "250px",
              boxShadow: "none",
              border: "none",
              height: 40,
            }),
            placeholder: (base) => ({
              ...base,
              color: "#8F99A6",
              fontSize: "12px",
            }),
            singleValue: (base) => ({
              ...base,
              color: "#4A5568",
              fontSize: "12px",
            }),
            menu: (base) => ({
              ...base,
              zIndex: 10,
              overflow: "hidden",
            }),
            menuList: (base) => ({
              ...base,
              padding: 0,
            }),
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isFocused ? "#EDF2F7" : "#FFFFFF",
              color: "#4A5568",
              fontSize: "12px",
              padding: "8px 12px",
              cursor: "pointer",
              "&:active": {
                backgroundColor: "#E2E8F0",
              },
            }),
          }}
          className="poppins-regular"
        />
      </div>
    );
  }

  return (
    <div
      className="poppins-regular rounded-md px-4 py-2 text-xs min-w-[155px]"
      style={{
        backgroundColor: "#F3F3F3",
        color: "#8F99A6",
      }}
    >
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-transparent focus:outline-none"
        style={{
          color: "#8F99A6",
        }}
      >
        {placeholder && (
          <option value="" disabled hidden>
            {placeholder}
          </option>
        )}
        {formattedOptions.map((option, index) => (
          <option key={index} value={option[valueKey]}>
            {option[labelKey]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CustomSelect;
